module.exports = __webpack_public_path__ + "static/elephantblanket-9a1769bc7cb571c52623767015e34fbc.png";